import type { BacklinksBacklinksCreatePayload } from "@similarweb/pro-api-client";
import type { IDynamicFilterRuleOverride } from "./include-exclude.types";

export function dynamicRulesFromQueryString(
    value?: string,
    defaultReturnData: IDynamicFilterRuleOverride[] = [],
): IDynamicFilterRuleOverride[] {
    if (!value) {
        return defaultReturnData;
    }
    try {
        return JSON.parse(decodeURIComponent(value)) as IDynamicFilterRuleOverride[];
    } catch (_e) {
        return defaultReturnData;
    }
}

export function DynamicRulesToQueryString(value?: IDynamicFilterRuleOverride[]): string {
    if (!value || value.length === 0) {
        return "";
    }

    return encodeURIComponent(JSON.stringify(value));
}

export function dynamicRulesToApiQueryPayloadFromQueryString(value?: string): BacklinksBacklinksCreatePayload {
    if (!value) {
        return [];
    }

    const formatted = dynamicRulesFromQueryString(value);

    return formatted.map((rule) => {
        return {
            ...rule,
            items: rule.items.map(({ text }) => text),
        };
    }) as unknown as BacklinksBacklinksCreatePayload;
}
